"use client";

import Image from "next/image";
import Link from "next/link";
import {
  ComponentSectionsPagePreviewList,
  Enum_Componentsectionspagepreviewlist_Variant,
  PageEntity,
  UploadFileEntityResponse,
} from "@/graphql/generated/graphql";
import { usePagePreview } from "@/lib/usePagePreview";
import { Container } from "./Container";
import { toDateString } from "@/lib/toDateString";
import { Headline } from "./Headline";
import { Paragraph } from "./Paragraph";

export interface IPagePreviewList {}

function PagePreviewList({
  tags,
  pages,
  title,
  columns = 3,
  hideSynopsis = false,
  pagePreviewListVariant,
  id,
  hierarchy,
  blogPage,
}: ComponentSectionsPagePreviewList & {
  pagePreviewListVariant: Enum_Componentsectionspagepreviewlist_Variant;
  columns: number;
}) {
  console.log({
    tags,
    pages,
    title,
    columns,
    hideSynopsis,
    pagePreviewListVariant,
    id,
    hierarchy,
    blogPage,
  });

  const { loadedPages } = usePagePreview({
    limit: 99,
    hierarchy,
    tags,
  });

  let pagesToRender: PageEntity[] = [];
  if (pages) {
    pagesToRender = [...pagesToRender, ...pages.data];
  }
  if (loadedPages) {
    pagesToRender = [...pagesToRender, ...loadedPages];
  }

  console.log("loadedPages", loadedPages);

  return (
    <Container className="grid grid-cols-2 md:grid-cols-3 gap-4">
      {loadedPages.map((page) => (
        <Link
          href={page?.attributes?.path || "#"}
          className="bg-boston-blue-50 px-8 pb-8 pt-4"
          key={page.id}
        >
          <div className="relative">
            <div className="absolute left-2 right-4 top-2 flex flex-wrap gap-x-4 gap-y-2">
              {page.attributes?.tags?.data?.map(
                (tag) =>
                  tag.attributes?.isVisible && (
                    <span className="bg-orange-300 p-1 text-xs" key={tag.id}>
                      {tag.attributes?.label}
                    </span>
                  )
              )}
            </div>
            {page?.attributes?.image?.data?.attributes?.url && (
              <Image
                alt={
                  page?.attributes?.image?.data?.attributes?.alternativeText ||
                  ""
                }
                src={page?.attributes?.image?.data?.attributes?.url || "#"}
                width={600}
                height={600}
                className="mt-4 aspect-1 object-cover"
              />
            )}
          </div>
          <div>
            <div className="mt-2">
              <BlogMetaLabelAndDate
                hierarchyLabel={
                  page.attributes?.hierarchy?.data?.attributes?.label
                }
                publicationDate={
                  page.attributes?.publicationDate ||
                  page.attributes?.publishedAt
                }
              />
            </div>
            <Headline variant="h3" className="mt-4 text-xl font-normal">
              {page.attributes?.title}
            </Headline>
            <Paragraph>{page.attributes?.synopsis}</Paragraph>
          </div>
        </Link>
      ))}
    </Container>
  );
}

export { PagePreviewList };

export function BlogMetaLabelAndDate({ hierarchyLabel, publicationDate }) {
  const publishDate = toDateString(publicationDate);
  return (
    <>{publishDate && <span className="text-gray-500">{publishDate}</span>}</>
  );
}
